import React, { useEffect, useState } from "react";
import defaultLogo from "../../../img/logo.png";
import { useBrandCtaVars } from "../../../hooks/useBrandCtaVars";
import "../../../styles/begin-play-btn.css";

function LevelComplete({ moveCount, optimalMoves, onNextLevel }) {
  const [brandUserData, setBrandUserData] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("userData");
      setBrandUserData(raw ? JSON.parse(raw) : null);
    } catch {
      setBrandUserData(null);
    }
  }, []);

  const { style: ctaVars, themed: ctaThemed } = useBrandCtaVars(brandUserData, defaultLogo);
  const isOptimal = moveCount <= optimalMoves;

  return (
    <div className="level-complete">
      <div className="level-complete__content">
        <div className="level-complete__title">
          {isOptimal ? "Perfect!" : "Level Complete!"}
        </div>

        <div className="level-complete__stars">
          {isOptimal ? "★★★" : moveCount <= optimalMoves * 1.5 ? "★★☆" : "★☆☆"}
        </div>

        <div className="level-complete__stats">
          <div className="level-complete__stat">
            <span className="level-complete__stat-label">Your Moves</span>
            <span className="level-complete__stat-value">{moveCount}</span>
          </div>
          <div className="level-complete__stat">
            <span className="level-complete__stat-label">Optimal</span>
            <span className="level-complete__stat-value">{optimalMoves}</span>
          </div>
        </div>

        <div className="level-complete__actions">
          <button
            type="button"
            className="begin-play-btn"
            style={ctaThemed ? ctaVars : undefined}
            onClick={onNextLevel}
          >
            Come on… one more?
          </button>
        </div>
      </div>
    </div>
  );
}

export default LevelComplete;
